export function passwordLength(string) {
    if (string.length <= 7) {
        return false;
    } else {
        return true;
    }
}

export function passwordUppercaseAndLowerCase(string) {
    if (string.match(/[a-z]/) && string.match(/[A-Z]/)) {
        return true;
    } else {
        return false;
    }
}

export function passwordContainsNumber(string) {
    if (string.match(/[0-9]/)) {
        return true;
    } else {
        return false;
    }
}

